import requestActionFactory from 'common/actions/requestActionFactory';
import DataV2 from 'common/DataV2';

import type { Onboarding } from 'common/api/endpoints/onboarding';
import type { Dispatch, GetState, State } from 'redux-connect';

const {
  requestAction,
  loadedAction,
  errorAction,

  RequestType,
  LoadedType,
  ErrorType,
} = requestActionFactory<Onboarding>('onboarding');

export const UpsertType = 'canny/onboarding/upsert';

export { RequestType, LoadedType, ErrorType };

export type UpsertOnboardingAction = Action & {
  type: typeof UpsertType;
  data: Onboarding;
};

const upsertAction = (data: Onboarding): UpsertOnboardingAction => ({
  type: UpsertType,
  data,
});

function fetchOnboarding() {
  return async (dispatch: Dispatch, getState: GetState) => {
    const cookies = getState().cookies;
    try {
      const response = await DataV2.fetch(DataV2.queries.onboarding, {}, cookies);
      return dispatch(loadedAction(response.onboarding));
    } catch (error) {
      if (typeof error === 'string') {
        return dispatch(errorAction(error));
      }
      return dispatch(errorAction('server error'));
    }
  };
}

export function reloadOnboarding() {
  return async (dispatch: Dispatch) => {
    dispatch(requestAction());
    return dispatch(fetchOnboarding());
  };
}

export function upsertOnboarding(data: Onboarding) {
  return (dispatch: Dispatch) => {
    dispatch(upsertAction(data));
  };
}

export function loadOnboarding() {
  return (dispatch: Dispatch, getState: GetState) => {
    if (shouldFetch(getState())) {
      dispatch(requestAction());
      return dispatch(fetchOnboarding());
    }

    return Promise.resolve();
  };
}

function shouldFetch(state: State) {
  return !state.onboarding.data || state.onboarding.error;
}
